const DEFAULTS = {
  config: {
    toolbar: {
      hidden: []
    }
  },
  configViewer: {
    getVideoUrl: (src) => `https://video.wixstatic.com/${src.pathname}`
  }
};
const DEFAULT_CONFIG = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    },
    textWrap: true
  }
});

export { DEFAULTS, DEFAULT_CONFIG, RICOS_DEFAULTS };
//# sourceMappingURL=defaults.js.map
